export {
    Type,
    JSON,
    fromJSON,
    fromBuffer,
    toBuffer,
    toHexString,
    fromHexString,
    instanceOf,
    encode,
    decode,
} from '../../plt/Cbor.js';
